module.exports = __webpack_public_path__ + "img/szw2.ee8a16a6.png";